// =============================================================================
// FLOATING SHOPPING BAG ICON COMPONENT
// =============================================================================
// Floating shopping bag icon for pages without navigation bar (like homepage)

import React from 'react';
import { ShoppingBag } from 'lucide-react';
import { useShoppingBag } from '@/contexts/ShoppingBagContext';
import './FloatingShoppingBagIcon.scss';

export const FloatingShoppingBagIcon: React.FC = () => {
  const { bag, toggleBag } = useShoppingBag();
  const itemCount = bag.totalItems;

  return (
    <button
      className="floating-shopping-bag-icon"
      onClick={toggleBag}
      aria-label={`Shopping bag with ${itemCount} item${itemCount !== 1 ? 's' : ''}`}
      type="button"
    >
      <ShoppingBag size={24} className="bag-icon" />
      {itemCount > 0 && (
        <span className="bag-badge" aria-hidden="true">
          {itemCount > 99 ? '99+' : itemCount}
        </span>
      )}
    </button>
  );
};

export default FloatingShoppingBagIcon;

